import Commander from "./Commander";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";
import events from "../framework/src/events/EventsObservable";
import {GAME_EVENTS} from "../framework/src/game/gameEvents";



export default class BigWin {

    constructor (commander) {
        this.commander = commander;
        this.BlinkAnimation = this.commander.BlinkAnimation;
        this.NormalWin = this.commander.NormalWin;
        this.WinCounter = this.commander.WinCounter;
        this.Coins = this.commander.Coins;

        this.layer = {
            coins: this.commander.layers.bigWin.children[0],
            flares: this.commander.layers.bigWin.children[1],
            frame: this.commander.layers.bigWin.children[2]
        };

        this.factors = {
            SuperMegaWin: this.commander.config.get(CONFIG_PARAMS.SUPER_WIN_FACTOR),
            MegaWin: this.commander.config.get(CONFIG_PARAMS.MEGA_WIN_FACTOR),
            BigWin: this.commander.config.get(CONFIG_PARAMS.BIG_WIN_FACTOR)
        };

        this.tween = {
            rotation: 0
        };
    }

    init() {
        this.Coins.create(this.layer.coins,640,360);

        this.flares = Commander.getSprite('BigWin_flares.png', 640, 360);
        this.background = Commander.getSprite('background_fullplate.png', 640, 360);
        this.background.scale.set(1.3, 1.2);
        this.mask = Commander.getSprite('BigWin_white_elipse.png', 640, 360);
        this.mask.scale.set(.8, 1);
        this.flares.mask = this.mask;

        this.layer.flares.addChild(this.background);
        this.layer.flares.addChild(this.flares);
        this.layer.flares.addChild(this.flares.mask);

        this.layer.flares.visible = this.layer.frame.visible = false;

        this.frame = Commander.getSprite('cover_01.png', 640, 400);
        this.layer.frame.addChild(this.frame);


        this.texts = {
            bigwin: Commander.getSprite("bigwin.png", 640, 210),
            megawin: Commander.getSprite("mega_win.png", 640, 210),
            ultrawin: Commander.getSprite("ultra_win.png", 640, 210)
        };
        this.texts.bigwin.alpha = this.texts.megawin.alpha = this.texts.ultrawin.alpha = 0;
        this.layer.frame.addChild(this.texts.bigwin);
        this.layer.frame.addChild(this.texts.megawin);
        this.layer.frame.addChild(this.texts.ultrawin);

        this.Freespins = this.commander.Freespins;
    }

    run(result, oldWin) {
        return new Promise(async res => {
            events.dispatch(GAME_EVENTS.GAME_BIGWIN);
            this.NormalWin.hideLogo();
            this.NormalWin.showGrid();

            let time = this.getTime(result.win, oldWin);
            await this.animStart();
            this.animateFlares(time);
            this.WinCounter.bigWin(
                time,
                result.win - oldWin,
                res
            );
            this.animateText(time);

            for (let line of result.lineWins) {
                this.NormalWin.lineAnim(line);
                await new Promise(resolve => setTimeout(resolve, 150)).then(() => {
                    this.NormalWin.lineAnimEnd(line);
                });
            }
            this.NormalWin.showAllWinPositions(result);
        }).then(() => {
            this.animEnd();
        });
    }

    animStart() {
        return new Promise (res => {
            this.layer.flares.visible = this.layer.frame.visible = true;
            this.Coins.run();
            let obj = {alpha: 0};
            createjs.Tween.get(obj)
                .to({alpha: 1}, 200)
                .call(() => {
                    Commander.removeTween(obj);
                    res();
                })
                .addEventListener('change', () => {
                    this.layer.flares.alpha = this.layer.frame.alpha = obj.alpha;
                });
        });
    }

    animEnd() {
        if (this.commander.freespins.isInFreeSpins()) {
            this.Freespins.showCounter();
        } else {
            this.NormalWin.showLogo();
        }
        this.NormalWin.resetWinPositions();
        this.NormalWin.hideLights();
        this.NormalWin.hideGrid();
        this.layer.flares.visible = this.layer.frame.visible = false;
        this.Coins.stop();
    }

    getTime(win, oldWin) {
        let factor = (win - oldWin) / this.commander.wallet.getBet();
        if (factor >= this.factors.SuperMegaWin) {
            return 25000;
        } else if (factor >= this.factors.MegaWin) {
            return 12000;
        } else if (factor >= this.factors.BigWin) {
            return 6000;
        }
    }

    animateFlares(time) {
        this.flares.rotation = 0;
        Commander.removeTween(this.flares);
        createjs.Tween.get(this.flares)
            .to({rotation: time / 750}, time+1000)
            .call(() => {
                this.commander.audio.playTrack("win_Fade_Out");
                Commander.removeTween(this.flares);
            });
    }

    animateText(time) {
        this.commander.audio.playTrack("bwin_Text_1");
        this.textAnimation(this.texts.bigwin, time, "big").then(() => {
            if (time >= 12000) {
                this.commander.audio.stopTrack("win_Bed_Loop");
                this.commander.audio.playTrack("bwin_Text_2");
                this.commander.audio.playTrack("bwin_Bed_MegaWin_Loop");

                this.textAnimation(this.texts.megawin, time, "mega").then(() => {
                    this.commander.audio.stopTrack("bwin_Bed_MegaWin_Loop");
                    this.commander.audio.playTrack("bwin_Bed_MegaWin_Stop");

                    if (time >= 25000) {
                        this.commander.audio.playTrack("bwin_Text_3");
                        this.commander.audio.playTrack("bwin_Bed_UltraWin_Loop");
                        this.textAnimation(this.texts.ultrawin, time, "ultra");
                    }
                });
            }
        });
    }

    textAnimation(sprite, time, type) {
        return new Promise(res => {
            this.showSprite(sprite, () => {
                BigWin.pulseSprite(sprite);
            });
            switch(type) {
                case "mega":
                case "big":
                    pixiSetTimeout(6, res);
                    break;
                case "ultra":
                    pixiSetTimeout(13, res);
                    break;
                case "fp":
                    pixiSetTimeout(3, res);
                    break;
            }
        }).then(() => {
            return new Promise(res => {
                if (BigWin.isEnd(time, type)) {
                    pixiSetTimeout(1, () => {
                        this.endSprite(sprite, res);
                    });
                } else {
                    this.shrinkSprite(sprite);
                    res();
                }
            });
        });
    }

    showSprite(sprite, callback = () => {}) {
        createjs.Tween.get(sprite)
            .to({alpha: 1}, 150)
            .call(() => {
                Commander.removeTween(sprite);
            });
        sprite.scale.set(0, 0);
        createjs.Tween.get(sprite.scale)
            .to({x: .9, y: .9}, 200)
            .call(() => {
                Commander.removeTween(sprite.scale);
                callback();
            });
    }

    shrinkSprite(sprite, callback = () => {}) {
        Commander.removeTween(sprite.scale);
        createjs.Tween.get(sprite.scale, {loop: true})
            .to({x: 0, y: 0}, 200)
            .call(() => {
                sprite.alpha = 0;
                Commander.removeTween(sprite.scale);
                callback();
            });
    }

    endSprite(sprite, callback = () => {}) {
        Commander.removeTween(sprite.scale);
        createjs.Tween.get(sprite.scale)
            .to({x: 6, y: 6}, 150)
            .call(() => {
                Commander.removeTween(sprite.scale);
                callback();
            });
        createjs.Tween.get(sprite)
            .to({alpha: 0}, 150)
            .call(() => {
                Commander.removeTween(sprite);
            });
    }

    static pulseSprite(sprite) {
        createjs.Tween.get(sprite.scale, {loop: true})
            .to({x: 1.1, y: 1.1}, 500)
            .to({x: .9, y: .9}, 500);
    }

    static isEnd(time, type) {
        if (time === 6000 && type === "big")
            return true;
        else if (time === 12000 && type === "mega")
            return true;
        else if (time === 25000 && type === "ultra")
            return true;
        else
            return false;
    }
}